module.exports = __webpack_public_path__ + "media/images/emblems/Knonau-blazon-21f25690ae466fa866d8187e2f067fab.svg";